import { createTheme } from '@mui/material/styles';

/**
 * Theme inspirovany hasicionline.cz (lib/theme.ts).
 * Cervena #C62828 + modra #1565C0 + Roboto + neutralni sede tony.
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#C62828',
      light: '#E53935',
      dark: '#B71C1C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1565C0',
      light: '#1976D2',
      dark: '#0D47A1',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '3.5rem', fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: '2.75rem', fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: '2rem', fontWeight: 600, lineHeight: 1.4 },
    h4: { fontSize: '1.5rem', fontWeight: 500, lineHeight: 1.4 },
    h5: { fontSize: '1.25rem', fontWeight: 500, lineHeight: 1.5 },
    body1: { fontSize: '1rem', lineHeight: 1.7 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.875rem',
          padding: '10px 24px',
        },
        containedPrimary: {
          '&:hover': { backgroundColor: '#B71C1C' },
        },
      },
    },
    MuiAppBar: {
      defaultProps: { color: 'default' },
      styleOverrides: {
        root: { backgroundColor: '#FFFFFF', color: '#212121' },
      },
    },
    // Dialog na mobilu (<md) = fullscreen, aby zabral celou obrazovku
    // (zdedeno z jsdh-notifikace-fe patternu — na telefonu je nabinech dialog vzdy fullscreen).
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          [theme.breakpoints.down('md')]: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%',
            borderRadius: 0,
          },
        }),
      },
    },
  },
});
